var $dependencyManager = (function () {
    // { dependencyName: <true/false> }
    // true if dependencyCallbacks were already called
    var dependencyLoaded = {}
    // { dependencyName: [callback1, callback2, ...] }
    var dependencyCallbacks = {}
    // { dependencyName: [['dependencyName1', 'dependencyName2', ...], ['dependencyName1', 'dependencyName3', ...]] }
    var groupDependencies = {}
    // { groupName: [callback1, callback2, ...] }
    // groupName = dependencyNames sorted and joined with ','
    var groupDependenciesCallbacks = {}
  
    function includesArray(haystack, needle) {
      var i, j, current;
      for (i = 0; i < haystack.length; ++i) {
        if (needle.length === haystack[i].length) {
          current = haystack[i];
          for (j = 0; j < needle.length && needle[j] === current[j]; ++j);
          if (j === needle.length)
            return true;
        }
      }
      return false;
    }
  
    var dependencyManager = {
      addDependency: function (dependency, isCss=false) {
        if (dependency['is_disabled'] == 'on') {
          return;
        }
        var allowedPages = (dependency.allowed_pages) ? dependency.allowed_pages.split(/\r?\n/) : [];
        var disabledPages = (dependency.disabled_pages) ? dependency.disabled_pages.split(/\r?\n/) : [];
        if (!this.isPageAllowed(allowedPages, disabledPages)) {
          return;
        }
        if (!isCss) {
          // Dependency is JavaScript
          var script = document.createElement('script')
          if (dependency.hasOwnProperty('name')) {
            if (!dependencyCallbacks.hasOwnProperty(dependency.name)) {
              dependencyLoaded[dependency.name] = false
            }
            if (!dependencyCallbacks.hasOwnProperty(dependency.name)) {
              dependencyCallbacks[dependency.name] = []
            }
            if (!groupDependencies.hasOwnProperty(dependency.name)) {
              groupDependencies[dependency.name] = []
            }
            if (!groupDependenciesCallbacks.hasOwnProperty(dependency.name)) {
              groupDependenciesCallbacks[dependency.name] = []
            }
    
            script.setAttribute('async', "")
            // Register onload to call callbacks after dependency is loaded
            script.setAttribute('onload', `(() => {$dependencyManager.dependencyLoaded('${dependency.name}')})()`)
          }
          for (const key of Object.keys(dependency)) {
            const value = dependency[key]
            script.setAttribute(key, value)
          }
          //document.body.appendChild(script)
  
        } else {
          // Dependency is CSS
          var link = document.createElement('link')
          link.setAttribute("rel", "stylesheet")
          for (const key of Object.keys(dependency)) {
            const value = dependency[key]
            link.setAttribute(key, value)
          }
          //document.body.appendChild(link)
        }
      },
      addDependencies: function (dependencies) {
        if (Object.keys(dependencies).includes("js")) {
          for (const dependency of dependencies.js) {
            $dependencyManager.addDependency(dependency)
          }
        }
        
        if (Object.keys(dependencies).includes("css")) {
          for (const dependency of dependencies.css) {
            $dependencyManager.addDependency(dependency, isCss=true)
          }
        }
      },
      addDependencyCallback: function (dependencyName, func, hasPriority = false) {
        if (!dependencyLoaded.hasOwnProperty(dependencyName) || !dependencyCallbacks.hasOwnProperty(
            dependencyName)) {
          dependencyCallbacks[dependencyName] = []
          dependencyLoaded[dependencyName] = false
        }
        if (dependencyLoaded[dependencyName]) {
          func()
        } else {
          if (hasPriority) {
            dependencyCallbacks[dependencyName].unshift(func)
          } else {
            dependencyCallbacks[dependencyName].push(func)
          }
        }
      },
      addDependenciesCallback: function (dependencyNames, func, hasPriority = false) {
        // If array with only one element handle like singular dependencyName
        if (Array.isArray(dependencyNames) && dependencyNames.length == 1) {
          $dependencyManager.addDependencyCallback(dependencyNames[0], func, hasPriority)
          return
        }
        for (const name of dependencyNames) {
          if (!groupDependencies.hasOwnProperty(name)) {
            groupDependencies[name] = []
          }
  
          var group = dependencyNames.filter((item) => item != name)
          if (!includesArray(groupDependencies[name], group)) {
            groupDependencies[name].push(group)
          }
        }
        var groupName = dependencyNames.sort().join(',')
        if (!groupDependenciesCallbacks.hasOwnProperty(groupName)) {
          groupDependenciesCallbacks[groupName] = []
        }
        if (hasPriority) {
          groupDependenciesCallbacks[groupName].unshift(func)
        } else {
          groupDependenciesCallbacks[groupName].push(func)
        }
  
        // Execute if already loaded
        var completeGroup = dependencyNames
  
        // All of group are loaded
        if (completeGroup.every((item) => dependencyLoaded[item])) {
          var groupName = completeGroup.sort().join()
          for (const func of groupDependenciesCallbacks[groupName]) {
            (func)()
          }
        }
      },
      dependencyLoaded: function (dependencyName) {
        dependencyLoaded[dependencyName] = true
        for (const func of dependencyCallbacks[dependencyName]) {
          (func)()
        }
  
        for (var group of groupDependencies[dependencyName]) {
          // All of group are loaded
          if (group.every((item) => dependencyLoaded[item])) {
            var completeGroup = Array.prototype.concat([dependencyName], group)
            var groupName = completeGroup.sort().join()
            for (const func of groupDependenciesCallbacks[groupName]) {
              (func)()
            }
          }
        }
  
      },
      isPageAllowed: function (allowedPages, disabledPages) {
        // disabled pages
        if (disabledPages.length > 0) {
  
          for (var i = 0; i < disabledPages.length; i++) {
            var page = disabledPages[i];
            if (this.pageMatches(page)) {
              return false;
            }
          }
        }
  
        // allowed pages
        if (allowedPages.length === 0 || allowedPages.every((el) => el == '')) {
          return true;
        }
        for (var i = 0; i < allowedPages.length; i++) {
          var page = allowedPages[i];
          if (this.pageMatches(page)) {
            return true;
          }
        }
        return false;
      },
  
      pageMatches: function (page) {
        const currentPage = window.location.pathname;
        if (page.startsWith("~") && page.endsWith("~")) {
  
          page = page.slice(1, -1);
          if (currentPage.includes(page)) {
            return true;
          }
  
        } else if (page.startsWith("~")) {
  
          page = page.substring(1);
          if (currentPage.endsWith(page)) {
            return true;
          }
  
        } else if (page.endsWith("~")) {
  
          page = page.slice(0, -1);
          if (currentPage.startsWith(page)) {
            return true;
          }
  
        }
  
        // No ~ in page string
        else {
  
          if (currentPage === page) {
            return true;
          }
  
        }
        return false;
      }
    }
  
    return dependencyManager;
  })();

// Attach $dependencyManager to the global window object
window.$dependencyManager = $dependencyManager;